var render = function render(){var _vm=this,_c=_vm._self._c;return _c('j-page',{staticClass:"j-components-layout"},[_c('div',{attrs:{"slot":"table"},slot:"table"},_vm._l((_vm.demo),function(name){return _c(name,{key:name,tag:"component"})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }